var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40864 3.44425C9.3937 3.42924 8.93562 3.31442 8.39077 3.18919C7.84585 3.06396 7.39413 2.98064 7.38687 3.0039C7.37967 3.02722 7.32328 3.40542 7.26164 3.84438C7.13779 4.72587 6.83794 5.75507 6.51753 6.39873C5.51882 8.40475 3.72695 9.73302 1.55365 10.0783L1.00023 10.1662L1.00023 11.0523L1.00023 11.9386L1.50183 12.0227C4.78814 12.5741 6.93065 15.0313 7.33145 18.7085C7.3576 18.9486 7.38887 19.145 7.40091 19.145C7.51175 19.145 9.34825 18.7024 9.38298 18.6674C9.40809 18.642 9.38941 18.4169 9.3414 18.1672C8.80997 15.4024 7.28835 13.1525 5.31375 12.2118L4.8401 11.9861L14.5802 11.9685L20.7393 11.9573L20.7393 10.1638L14.5644 10.1526L4.84722 10.1348L5.44521 9.83185C6.99651 9.04591 8.22472 7.5042 8.948 5.43484C9.15411 4.8453 9.4651 3.50124 9.40864 3.44425Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4acb23c26584f9062752deb5343db62c.svg";
export { ForwardRef as ReactComponent };